import { useEffect } from 'react';

import { browserMetrics } from '@atlassian/browser-metrics';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

export type Props = {
	name: string;
};
const PageLoadMarkComponent = ({ name }: Props) => {
	const pageLoadMetric = browserMetrics.getPageLoadMetric();
	useEffect(() => {
		pageLoadMetric.mark(name);
	}, [pageLoadMetric, name]);

	return null;
};

export const PageLoadMark = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(PageLoadMarkComponent);
